import styled from 'styled-components';
import { fontStyle, flexPosition } from '../../styles/mixins';
import {
  FONT_SIZE_6,
  FONT_SIZE_7,
  GRAY_LIGHTER,
  GRAY_DARKER,
  INFO_COLOR,
} from '../../styles/variables';
import { ButtonToolbar } from '../ActionBtn/style';

export const VariationItem = styled.div`
  border-radius: 3px;
  box-shadow: ${({ isDragging }) => (isDragging ? '0 4px 10px 0 rgba(0, 0, 0, 0.25)' : 'none')};
  height: ${props => (props.open ? 'auto' : 'auto')};
  margin-bottom: ${({ noMargin }) => (noMargin ? '0px' : '15px')};
  margin-right: ${({ noMargin }) => (noMargin ? '0px' : '15px')};
  ${fontStyle('white', FONT_SIZE_6, '600')}
`;

export const Header = styled.div`
  background-color: #4a90e2;
  border-radius: 3px 3px 0 0;
  padding: 15px;
  width: 100%;
`;

export const FirstBar = styled.div`
  ${flexPosition({ justify: 'space-between' })}
  line-height: 19px;

  > ${ButtonToolbar} {
    height: 26px;
    margin: -7px -15px 0 0;
    padding: 7px 15px 0;
    width: auto;

    > div {
      align-items: center;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
`;

export const SecondBar = styled.div`
  ${flexPosition({ justify: 'space-between' })}
  ${fontStyle('white', FONT_SIZE_7, '600')}
  line-height: 17px;
  margin-top: 10px;
`;

export const ToggleButton = styled.span`
  ${fontStyle(INFO_COLOR, FONT_SIZE_7, '600')}
  ${flexPosition({ justify: 'flex-end' })}
  cursor: pointer;
`;

export const Container = styled.ul`
  list-style: none;
  margin: 0 15px 0 0;
  padding: 0;

  > li {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Body = styled.div`
  ${({ open }) =>
    flexPosition({
      align: open ? 'initial' : 'center',
      justify: 'space-between',
    })}
  background-color: #FFF;
  border-radius: 0 0 3px 3px;
  border: 1px solid ${GRAY_LIGHTER};
  border-top: none;
  display: flex;
  flex-direction: ${({ open }) => (open ? 'column' : 'initial')};
  line-height: 1;
  padding: 15px;

  > ${Container} {
    display: ${({ open }) => (open ? 'block' : 'flex')};
    width: ${({ open }) => (open ? '100%' : '80%')};
  }

  > ${ToggleButton} {
    margin-top: ${({ open }) => (open ? '15px' : '0')};
  }
`;

export const CollapsedItem = styled.li`
  list-style: none;
  width: 100%;
`;

export const InlineItems = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, '600')}
  display: inline-block;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const List = styled.ul`
  padding: 0;
  overflow: auto;
`;

export const ListItem = styled.li`
  ${flexPosition({ justify: 'space-between' })}
  line-height: 14px;
  list-style: none;
  margin-bottom: 15px;
`;

export const Name = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, '600')}
`;

export const Price = styled.span`
  ${fontStyle(INFO_COLOR, FONT_SIZE_7, '800')}
`;



// WEBPACK FOOTER //
// ./src/components/VariationItem/style.js